import React, { useState } from 'react';
import Admin from '../pages/Admin';

const ProtectedAdmin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [authedPassword, setAuthedPassword] = useState('');
  const [error, setError] = useState('');

  // Password comes from the REACT_APP_ADMIN_PASSWORD environment variable
  // (set it in Emergent / hosting env, NOT in code — that way pulls never
  // revert it and it stays out of source control). Falls back only if unset.
  const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'PalmBay2024!';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setAuthedPassword(password);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return <Admin adminPassword={authedPassword} />;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Admin Access</h1>
        <p className="text-slate-600 mb-6">Enter password to access the lead management dashboard</p>
        
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-2">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
              placeholder="Enter admin password"
              required
            />
          </div>
          
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}
          
          <button
            type="submit"
            className="w-full py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition-colors"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProtectedAdmin;
